// extracted by mini-css-extract-plugin
export default {"section":"Te1ud6","headingLink":"Ubdsn2","list":"SV0oLw","item":"q6_Oo0","itemLink":"k9NJSU","searchFadeIn":"pS1syz"};